import { UserType } from "../enums/user-type.enum";

export class UserParam {
  name: string;
  subtype: UserType;
  active: boolean;

  locationId: number;
  obsId: number;

  employeeNumber: string;
  employeeClassId: number;

  isResourceManagerNotSet: boolean;
}